import { useReducer } from 'react';
import reducer, { defaultState } from './reducer';
import logger from 'use-reducer-logger';
import * as actions from './actions';

export default function useFetchItems() {

    const [state, dispatch] = useReducer(logger(reducer), defaultState);

    const fetch = actions.fetchItems(dispatch);

    return {
        state,
        fetch        
    }
}